import React, { useLayoutEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (newValue: any) => {
    onChange(newValue);
  };

  const phoneInputRef = useRef<any>(null);
  useLayoutEffect(() => {
    phoneInputRef.current?.focus();
  }, []);
  return (
    <PhoneInput
      isFocused={true}
      international
      onChange={handleChange}
      defaultCountry="US"
      placeholder="Enter phone number"
      value={value}
      ref={phoneInputRef}
    />
  );
};

export default PhoneNumberInput;
